<section>
  <div class="row justify-content-center">
    <div class="col-xm-10 col-sm-10 col-md-8 col-lg-5 col-xl-5 customMenu mb-1">
      <app-opencv-menu></app-opencv-menu>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-xm-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 customCamera2">
      <app-camera></app-camera>
    </div>
  </div>
</section>
